import { put, takeEvery } from 'redux-saga/effects';
import { SET_ERROR } from '../constants';
import { setError } from '../actions/error.js';

export function* handleError(action) {
  const {
    error: { message },
  } = action.payload;
  yield put(setError({ error: message }));
}

export function* errorSaga() {
  yield takeEvery(SET_ERROR, handleError);
}



// WEBPACK FOOTER //
// ./src/redux/sagas/error.js